export const truncateString = ({ str = "", max = 0 }) => {
	if (str && max > 0) {
		const newString = str.toString();
		return newString.length > max ? newString.substring(0, max) + ".." : str;
	} else {
		return str;
	}
};
